

import styled from "styled-components"
import NakliyeFeribotInput from "../../shared/input/nakliyeHesaplama/NakliyeFeribotUcretInput";
import { useDispatch, useSelector } from "react-redux";
import useWindowDimensions from "../../../hooks/useWindowSize";
import { deleteCurrentFerryItem } from "../../../features/nakliyeHesaplama/nakliyeHesaplamaSlice";


const Container = styled.div`
    width: ${({width}) => width};
    color: ${({theme}) => theme.mainTextColor};

    h4{
     font-size: 10px;
     font-weight: var(--font-weight-md);
     margin: 5px 0;
     
    }
    .list{
        display: flex;
        flex-direction: column;

        .list-item{
            display: flex;
            font-size: 12px;
            font-weight: var(--font-weight-lg);
            height: 35px;

            .list-item-content{
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: calc(100% - 40px);
                border-bottom: 1px solid ${({theme}) => theme.mainTextColor};
                
                .name{


                }

                .price{
                    
                }
            }

            .last{
                border-bottom: none;

            }
            .delete-btn{
                width: 40px;
                cursor: pointer;
                height: 100%;
            }

        }




    }

`
const FerryPriceList = () => {

    const dispatch = useDispatch()

    const {
        currentFerryList,
      } = useSelector(state => state.nakliyeHesaplama)

    const {windowDimensions} = useWindowDimensions()

  return (
    <Container width={windowDimensions.width <= 1400 ? "100%" : "320px"}>
        <NakliyeFeribotInput labelText={"Feribot Ücreti"} name={"feribotUcreti"} inputWidth={"100%"}/>
        {
            currentFerryList.length > 0 &&
            <h4>Eklenenler</h4>
        }
        <div className="list">
            {
                currentFerryList.map((item, i) => (
                    <div className="list-item">
                        <div className={i+1 === currentFerryList.length ? "list-item-content last" : "list-item-content"}>
                            <div className="name">
                                {item.seferIsmi === "IDOESKİHİSAR" && "İDO-ESKİHİSAR-TOPÇULAR"}
                                {item.seferIsmi === "NEGMARESKİHİSAR" && "NEGMAR-ESKİHİSAR-TAVŞANLI"}
                                {item.seferIsmi === "TRAMOLABANDIRMA" && "TRAMOLA-BANDIRMA-AMBARLI"}
                                ({item.aracTipi})
                            </div>
                            <div></div>
                            <div className="price">{item.ucret} TL</div>
                        </div>
                        <button className="delete-btn"onClick={() => dispatch(deleteCurrentFerryItem(item))}>Sil</button>
                    </div>
                ))
            }
        </div>
    </Container>
  )
}

export default FerryPriceList